import CheckboxCustom from '@/components/ui/Checkbox'
import {useBoundStore, useCommonsStore} from '@/store/boundStore'
import React, {useMemo, useRef, useState} from 'react'
import Title from '@components/ui/Title'
import {useTranslation} from 'react-i18next'
import StepClinicalInfoCta from '@pages/clinicalInfo/steps/StepClinicalInfoCta.tsx'
import {StyledContainerAddOther, StyledContainerCheckBox} from '@pages/clinicalInfo/style.ts'
import {StepContainer} from '@pages/onBoarding/styles.ts'
import Input from 'src/components/ui/InputText'
import {Form} from 'reactstrap'

const StepPatology: React.FC = () => {
	const {t} = useTranslation()
	const {pathologies, otherPathologies, setClinicalInfoData, userType} = useBoundStore()
	const {cardsData} = useCommonsStore()
	const bodyRef = useRef<HTMLDivElement>(null)

	const [nobody, setNobody] = useState(false)
	const [other, setOther] = useState(false)

	const pathologiesList = useMemo(() => {
		return cardsData?.clinical_data?.pathologies
	}, [cardsData])

	const onCheckboxBtnClick = (selected: number) => {
		setNobody(false)
		const index = pathologies?.indexOf(selected)
		if (index < 0) {
			pathologies?.push(selected)
		} else {
			pathologies?.splice(index, 1)
		}
		setClinicalInfoData('pathologies', [...pathologies])
	}

	const scrollToRef = () => {
		if (bodyRef.current) {
			bodyRef.current.scrollIntoView({behavior: 'smooth'})
		}
	}

	const handleNobody = () => {
		setNobody(!nobody)
		setClinicalInfoData('pathologies', [])
		setOther(false)
	}

	const handleOther = () => {
		setOther(!other)
		setNobody(false)
		setClinicalInfoData('otherPathologies', '')
		setTimeout(() => {
			scrollToRef()
		}, 500)
	}

	return (
		<>
			<StepContainer>
				<Title
					title={t(`${userType}:clinical_information:pathologies:title`)}
					subTitle={t(`${userType}:clinical_information:pathologies:subtitle`)}
				/>
				<Form>
					<StyledContainerCheckBox>
						<CheckboxCustom
							check={nobody}
							onChange={handleNobody}
							name={t('commons:nothing') || ''}
							description={''}
							label={t('commons:nothing') || ''}
						/>
						{pathologiesList?.map((pathology, index) => {
							return (
								<CheckboxCustom
									key={index}
									check={pathologies.includes(pathology.id)}
									onChange={() => onCheckboxBtnClick(pathology.id)}
									name={pathology.name}
									description={pathology.description}
									label={pathology.name}
								/>
							)
						})}
						<div>
							<CheckboxCustom
								check={other}
								onChange={handleOther}
								name={t('commons:other') || ''}
								label={t('commons:other') || ''}
							/>

							{other && (
								<StyledContainerAddOther>
									<div ref={bodyRef} />
									<Input
										type="text"
										label={t('commons:form:pathology')}
										placeholder={t('commons:form:pathology') || ''}
										onChange={e => setClinicalInfoData('otherPathologies', e.target.value)}
										value={otherPathologies}
									/>
								</StyledContainerAddOther>
							)}
						</div>
					</StyledContainerCheckBox>
				</Form>
			</StepContainer>
			<StepClinicalInfoCta />
		</>
	)
}

export default StepPatology
